import { Link } from "react-router-dom";
import { TownEyeLogo } from "@/components/TownEyeLogo";

export default function TermsPage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--te-bg)" }}>
      <header className="te-glass-header sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="terms-logo-link"><TownEyeLogo /></Link>
          <Link to="/" className="text-sm font-medium text-[var(--te-primary)] hover:underline" data-testid="terms-back-link">Back home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="te-eyebrow mb-3">Legal</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[var(--te-text)]">Terms of Service</h1>
        <p className="text-sm text-[var(--te-text-muted)] mt-2">Last updated: February 2026</p>

        <article className="prose prose-neutral max-w-none mt-10 space-y-6 text-[var(--te-text)] leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">1. Welcome to TownEye</h2>
            <p>By creating an account or using TownEye (towneye.app), you agree to these Terms of Service. Please read them carefully. If you do not agree, please do not use TownEye.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">2. Eligibility</h2>
            <p>You must be at least 13 years old to create an account. By signing up you confirm you meet this requirement and the information you provide is accurate.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">3. Your account</h2>
            <p>You are responsible for keeping your password secure and for all activity that happens under your account. Notify us immediately of any unauthorized use. We may suspend or terminate accounts that violate these terms.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">4. Community guidelines</h2>
            <p>TownEye exists to make neighborhoods better. You agree not to post content that is unlawful, harassing, hateful, defamatory, sexually explicit, or that infringes on others&apos; rights. Reports should be factual and respectful.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">5. Your content</h2>
            <p>You retain ownership of the content you post. By posting, you grant TownEye a non-exclusive, worldwide license to display, distribute, and store your content as needed to operate the service.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">6. Moderation</h2>
            <p>TownEye moderators and admins may remove content, change report statuses, or take account action when content violates these terms or the community guidelines.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">7. Disclaimer</h2>
            <p>TownEye is provided &quot;as is&quot; without warranties of any kind. We do our best to keep the service accurate and available but cannot guarantee uptime or that reports will be acted on by city services.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">8. Changes</h2>
            <p>We may update these terms from time to time. Material changes will be announced on towneye.app. Continued use after changes constitutes acceptance.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">9. Contact</h2>
            <p>Questions? Reach us at hello@towneye.app.</p>
          </section>
        </article>

        <div className="mt-12 pt-8 border-t border-[var(--te-divider)] flex items-center justify-between text-sm">
          <Link to="/privacy" className="text-[var(--te-primary)] hover:underline font-medium" data-testid="terms-link-privacy">Read our Privacy Policy →</Link>
          <Link to="/register" className="te-btn-primary py-2 px-5 text-sm" data-testid="terms-cta-signup">Create account</Link>
        </div>
      </main>
    </div>
  );
}
